import script from "./CustomButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomButton.vue?vue&type=script&lang=ts&setup=true"

import "./CustomButton.vue?vue&type=style&index=0&id=f5abfeb8&scoped=true&lang=css"

import exportComponent from "/Users/nana/LFMG/ionic-apps/vxt-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5abfeb8"]])

export default __exports__